import { render, staticRenderFns } from "./addHokl.vue?vue&type=template&id=119387c0&scoped=true"
import script from "./addHokl.vue?vue&type=script&lang=js"
export * from "./addHokl.vue?vue&type=script&lang=js"
import style0 from "./addHokl.vue?vue&type=style&index=0&id=119387c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119387c0",
  null
  
)

export default component.exports